module.exports = __webpack_public_path__ + "assets/951f9206bcdc4b82b1c782555cb2cd38.mp3";